import { CoursePortfolios } from 'pages/corporate_reports/CoursePortfolios';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports/course_portfolios',
  route: 'course_portfolios',
  label: 'Portfólio de Cursos',
  parentName: 'corporate_reports',
  list: CoursePortfolios,
  actions: ['list', 'export']
};

export default generateResources(resource);
